// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-MyAccount__myAccount__root","user":"cmp-MyAccount__myAccount__user","subtitle":"cmp-MyAccount__myAccount__subtitle"};